export default "__VITE_ASSET__DURcxbCv__"